import { AssignmentAudio } from "components/AssignmentAudio";
import { AssignmentImage } from "components/AssignmentImage";
import Latex from "react-latex-next";
import { useAssetUrlResolver } from "utils/hooks/useAssetUrlResolver";

interface Props<
  T = {
    assignmentText?: string | null | undefined;
    assignmentImage?: string | null | undefined;
    assignmentImageThumbHash?: string | null | undefined;
    AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null | undefined;
    assignmentAudio?: string | null | undefined;
    [key: string]: unknown;
  },
> {
  assignment: T | null | undefined;
}

export const AssignmentPrompt: React.FC<Props> = ({ assignment }) => {
  const imageUrl = useAssetUrlResolver(assignment?.assignmentImage);
  const audioUrl = useAssetUrlResolver(assignment?.assignmentAudio);

  if (!assignment?.assignmentText && !imageUrl && !audioUrl) {
    return null;
  }

  return (
    <div>
      <Latex>{assignment?.assignmentText ?? ""}</Latex>
      {!!assignment?.assignmentImage && (
        <AssignmentImage
          src={imageUrl}
          alt="Assignment"
          thumbHash={assignment?.assignmentImageThumbHash}
          width={assignment?.AssignmentImageDimensions?.width}
          height={assignment?.AssignmentImageDimensions?.height}
        />
      )}
      {!!audioUrl && <AssignmentAudio audioSrc={audioUrl} />}
    </div>
  );
};
